import { createSlice } from "@reduxjs/toolkit";
import { deleteReviewsAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const deleteReviewSlice = createSlice({
  name: "deleteReview",
  initialState: data,
  reducers: {
    deleteReviewSlice(state) {
      state.isLoading = true;
    },
    deleteReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    deleteReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    deleteReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const deleteReviewHandler = (id:any,unpublish:any) => async (dispatch: any) => {
  try {
    dispatch(deleteReviewAction.deleteReviewSlice());
    const response: any = await deleteReviewsAPI(id,unpublish);
    dispatch(deleteReviewAction.deleteReviewSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(deleteReviewAction.deleteReviewSliceFailure(e?.response?.data?.message));
    dispatch(deleteReviewAction.deleteReviewSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default deleteReviewSlice.reducer;
export const deleteReviewAction = deleteReviewSlice.actions;
